/* ═══════════════════════════════════════════════════════════════════
   APTUX WAY — Sticky CTA web component
   Shows a fixed bottom bar after the user scrolls past a threshold.
   Mobile-focused but works on all sizes.
   ═══════════════════════════════════════════════════════════════════ */

class AptuxStickyCta extends HTMLElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.threshold || '600', 10);
    this.visible = false;

    // Hidden by default
    this.classList.remove('aw-sticky-visible');

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const past = window.scrollY > this.threshold;
    // Hide again near the very bottom so it doesn't overlap the footer CTA
    const nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 200);
    const shouldShow = past && !nearBottom;

    if (shouldShow !== this.visible) {
      this.visible = shouldShow;
      this.classList.toggle('aw-sticky-visible', shouldShow);
    }
  }
}

if (!customElements.get('aptux-sticky-cta')) {
  customElements.define('aptux-sticky-cta', AptuxStickyCta);
}
